import { ENotAuthNavigation } from '@hts/shared/enums';
import { IMappedQuickCategoryItem } from '@hts/shared/types';
import { HtsTypography } from '@hts/shared/ui';
import { memo, useCallback } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import styles from '../styles/CategoryListSection.module.scss';

interface ICategoryListSectionProps {
  label: string;
  categories: IMappedQuickCategoryItem[];
}

export const CategoryListSection: React.FC<ICategoryListSectionProps> = memo(
  ({ label, categories }) => {
    const renderCategory = useCallback(
      (
        {
          id,
          fileUrl,
          fileUrlThumbnail,
          title,
          slug,
          categoryId,
          position,
        }: IMappedQuickCategoryItem,
        index: number
      ) => {
        const url = fileUrlThumbnail || fileUrl;
        const src = url ? url : '/assets/images/ihopetoseeyou-logo.png';

        return (
          <li key={`${id}-${index}`} className={styles.categoryItemContainer}>
            <Link to={`${ENotAuthNavigation.CATEGORY_OF_CARD}/${slug}`}>
              <LazyLoadImage
                src={src}
                alt={title || 'Category'}
                effect="blur"
                wrapperClassName={`${styles.imageWrapper} ${!url ? styles.defaultImageWrapper : ''}`}
              />

              <HtsTypography variant="h3" element="h2" className={styles.categoryLabel}>
                {title}
              </HtsTypography>
            </Link>
          </li>
        );
      },
      []
    );

    return (
      <div className={styles.container}>
        <HtsTypography variant="h1">{label}</HtsTypography>

        <ul className={styles.categoriesContainer}>{categories.map(renderCategory)}</ul>
      </div>
    );
  }
);
